import React from "react";
import ReactLoading from "react-loading";

const SpiningBubbleLoading = () => (
  <div className="flex-1 w-full h-full flex justify-center items-center">
    <ReactLoading
      type={"spinningBubbles"}
      color={"#69C9D7"}
      height={70}
      width={70}
    />
  </div>
);

export default SpiningBubbleLoading;
